export default {
    punchLog: 'Punch Log',
    searchByEmployeeNoOrName: 'Search by Employee name, ID, Bureau',
    search: 'Search',
    employeeId: 'Employee Id',
    employeeName: 'Employee Name',
    bureau: 'Bureau',
    image: 'Image',
    method: 'Method',
    location: 'Location',
    date: 'Date',
    time: 'Time',
    temperature: 'Temp',
    exportPDF: 'Export PDF',
    exportExcel: 'Export Excel',
    somethingWrong: 'Something went wrong'
}
